'use client';

import { useEffect } from 'react';
import { Ev, initAnalytics, track } from '@/utils/util_analytics';

export default function BusinessAnalytics() {
    useEffect(() => {
        initAnalytics();
        track(Ev.app_launch);
    }, []);

    return null;
}
